import EditIcon from '@usas/ui-web/components/icons/EditIcon';
import DeleteIcon from '@usas/ui-web/components/icons/DeleteIcon';

import global from '@usas/ui-web/components/GlobalStyle.module.css';

const GridRow = ({ socialMedia, onEditClicked, onDeleteClicked }) => (
  <div className={global.SmallTableRow}>
    <div className={global.SmallTableRowHead}>
      <span className='hidden-xs'>{socialMedia.socialMediaType?.typeName || <span>&nbsp;</span>}</span>&nbsp;
      <div className={global.FloatRight}>
        <button className={global.IconButtonMobileMargin} type="button" onClick={(e) => onDeleteClicked(e, socialMedia)}>
          <DeleteIcon />
        </button>
        <button className={global.IconButtonMobileMargin} type="button" onClick={(e) => onEditClicked(e, socialMedia)}>
          <EditIcon />
        </button>
      </div>
    </div>
    <div className={global.SmallTableRowInfo}>
      <div className='row'>
        <div className={['col-xs-6 visible-xs', global.SmallTableRowLabels].join(' ')}>
          Social Media Platform
        </div>
        <div className={['col-xs-6 visible-xs', global.SmallTableRowData].join(' ')}>
          {socialMedia.socialMediaType?.typeName || <span>&nbsp;</span>}
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowLabels].join(' ')}>
          Handle / Username / Url
        </div>
        <div className={['col-xs-6 col-sm-3', global.SmallTableRowData].join(' ')}>
          {socialMedia.socialHandle || <span>&nbsp;</span>}
        </div>
      </div>
    </div>
  </div>
);

const SocialMediaGridSmall = ({ gridData, isLoading, onEditClicked, onDeleteClicked }) => (
  <div className={[global.SmallTable, 'hidden-md hidden-lg'].join(' ')}>
    {isLoading === true
      ? (
        <div className={global.SmallTableRow}>
          <div className={global.SmallTableRowHead}>&nbsp;</div>
          <div className={global.SmallTableRowInfo}>
            <div className={global.SmallTableRowLabels}>Loading...</div>
          </div>
        </div>
      ) : Array.isArray(gridData) && gridData.length > 0
        ? gridData.map((socialMedia, i) => <GridRow key={i} socialMedia={socialMedia} onEditClicked={onEditClicked} onDeleteClicked={onDeleteClicked} />)
        : (
          <div className={global.SmallTableRow}>
            <div className={global.SmallTableRowHead}>&nbsp;</div>
            <div className={global.SmallTableRowInfo}>
              <div className={global.SmallTableRowLabels}>No Socials</div>
            </div>
          </div>
        )
    }
  </div>
);

export default SocialMediaGridSmall;